import { Directive, EventEmitter, Output, Input, ElementRef, HostListener } from '@angular/core';
import { Polygon } from './measureTool';
import * as ol from 'openlayers';

@Directive({
  selector: '[lPolygon]'
})
export class PolygonDirective {

  @Input('lPolygon')
  public drawType: string;

  @Input()
  public map: ol.Map;

  @Input()
  public strokeColor: string;
  @Input()
  public fillColor: string;

  @Output()
  drawSartEvent: EventEmitter<any> = new EventEmitter();

  @Output()
  drawEndEvent: EventEmitter<any> = new EventEmitter();

  constructor(private _ele: ElementRef) { }

  @HostListener('click') onClick(event: Event) {
    this.drawSartEvent.emit();
    let draw: Polygon = new Polygon(this.drawType, e => { this.drawEndEvent.emit(e); draw = null; }, this.map);
    event.stopPropagation();
  }

}
